<template>
  <div class="archived-section">
    <div
      v-if="pending"
      class="text-center p-4"
    >
      <Loader />
    </div>
    <div
      v-else-if="listings.length === 0"
      class="text-center text-secondary p-4"
    >
      Brak zarchiwizowanych ofert
    </div>
    <div
      v-else
      class="archived-list"
    >
      <div
        v-for="listing in listings"
        :key="listing.id"
        class="archived-row d-flex align-items-center justify-content-between px-3 py-2"
      >
        <div class="d-flex align-items-center">
          <i class="far fa-archive text-secondary mr-2" />
          <span class="listing-name">{{ listing.name }}</span>
        </div>
        <button
          class="btn btn-sm btn-outline-primary"
          :disabled="restoringIds.includes(listing.id)"
          @click="restore(listing)"
        >
          <Loader
            v-if="restoringIds.includes(listing.id)"
            size="14px"
            color="#007bff"
            style="position: relative; top: 1px; margin-right: 4px;"
          />
          <i
            v-else
            class="fas fa-undo mr-1"
          />
          Przywróć
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ArchivedListingsList',
  props: {
    listings: {
      type: Array,
      default: () => [],
    },
    pending: {
      type: Boolean,
      default: false,
    },
    catalogId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    restoringIds: [],
  }),
  methods: {
    ...mapActions('shop', ['restoreListing']),
    async restore(listing) {
      this.restoringIds = [...this.restoringIds, listing.id];
      try {
        await this.restoreListing({
          params: { catalogId: this.catalogId },
          data: [listing.id],
        });
        this.$emit('restored', listing.id);
      } finally {
        this.restoringIds = this.restoringIds.filter((id) => id !== listing.id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.archived-section {
  border-top: 1px solid #efefef;
}

.archived-list {
  max-height: calc(100vh - 320px);
  overflow-y: auto;
}

.archived-row {
  border-bottom: 1px solid #f5f5f5;

  &:hover {
    background: #fafafa;
  }
}

.listing-name {
  font-size: 14px;
  color: #555;
}
</style>
